import { PendingProfileDocument } from './PendingProfileDocument'
import { StoredProfileDocument } from './StoredProfileDocument'

interface ChipDocument {
    documentId: string
    fileName: string
    removalIncomplete?: boolean
}

interface ProfileDocumentChipsProps<D extends ChipDocument> {
    stored: D[]
    pending: File[]
    canRemove: boolean
    busy: boolean
    removingId: string | null
    removalDescription?: (document: D) => string
    onOpen: (document: D) => void
    onRemoveStored: (document: D) => void
    onPreviewPending: (file: File, index: number) => void
    onRemovePending: (file: File) => void
}

/** One card's files: the stored documents of a saved profile, and the files waiting for the first save. */
export const ProfileDocumentChips = <D extends ChipDocument>({
    stored,
    pending,
    canRemove,
    busy,
    removingId,
    removalDescription,
    onOpen,
    onRemoveStored,
    onPreviewPending,
    onRemovePending,
}: ProfileDocumentChipsProps<D>) => (
    <div className="mt-1.5 flex flex-wrap gap-1.5">
        {stored.map((document) => (
            <StoredProfileDocument
                key={document.documentId}
                fileName={document.fileName}
                removalIncomplete={Boolean(document.removalIncomplete)}
                canRemove={canRemove}
                busy={busy}
                removing={removingId === document.documentId}
                onOpen={() => onOpen(document)}
                onRemove={() => onRemoveStored(document)}
                removalDescription={removalDescription?.(document)}
            />
        ))}
        {pending.map((file, index) => (
            <PendingProfileDocument
                key={`${file.name}-${file.lastModified}-${index}`}
                file={file}
                onPreview={() => onPreviewPending(file, index)}
                onRemove={() => onRemovePending(file)}
            />
        ))}
    </div>
)
